import { DrainPipeProduct, Product, ProductType } from '../';

export function IsDrainPipeProduct(product: Product): product is DrainPipeProduct {
  return (product as DrainPipeProduct).productType === ProductType.DRAIN_PIPE;
}
